<template>
  <div>
    <!--
    name: '',//the name of the type
    step: '',//number of steps in minuts
    rra: [],// ["AVERAGE", "MIN", "MAX","LAST"]
    minimum: 'U',
    maximum: 'U',
    dst: ''//["GAUGE","COUNTER","ABSOLUTE","DERIVED",]
    -->
    <el-form>
      <el-form-item v-if="name_check" label='name'>
        <el-input v-model="Sensor.name"></el-input>
      </el-form-item>
      <el-form-item label="step">
        <el-input v-model.number="Sensor.step"></el-input>
      </el-form-item>
      <el-form-item label="rra">
        <el-checkbox-group v-model="Sensor.rra">
          <el-checkbox v-for="(item,index) in rra" :key="index" :label="item" :name="item"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="minimum">
        <el-input v-model.number="Sensor.minimum"></el-input>
      </el-form-item>
      <el-form-item label="maximum">
        <el-input v-model.number="Sensor.maximum"></el-input>
      </el-form-item>
      <el-form-item label="dst">
        <el-radio-group v-model="Sensor.dst">
          <el-radio v-for="(item,index) in dst" :key="index" :label="item">

          </el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <!--<el-button @click="submit">submit</el-button>-->
  </div>
</template>

<script>
  import ElForm from "element-ui/packages/form/src/form";
  import ElFormItem from "element-ui/packages/form/src/form-item";
  import ElInput from "element-ui/packages/input/src/input";
  import sensor_type from "../../../Class/sensor_type"

  export default {
    components: {
      ElInput,
      ElFormItem,
      ElForm
    },
    name: "SensorTypeForm",
    data() {
      return {
        /*Sensor:{
          name: '',//the name of the type
          step: '',//number of steps in minuts
          rra: [],// ["AVERAGE", "MIN", "MAX","LAST"]
          minimum: 'U',
          maximum: 'U',
          dst: ''//["GAUGE","COUNTER","ABSOLUTE","DERIVED",]
        },*/
        dst: ["GAUGE", "COUNTER", "ABSOLUTE", "DERIVED"],
        rra: ["AVERAGE", "MIN", "MAX", "LAST"],
        name_check: false
      }
    }, props: {
      Sensor: {
        type: Object,
        required: true
      }
    }, methods: {
      submit() {
        /*console.log('**************** submit In sensor-type-form *****************');
        console.log(Object.values(this.Sensor));
        (new sensor_type(this.Sensor)).addSensorType('default').then(s=>{
          //console.log('succes',s)
        }).catch(e=>{
          //console.error('error',e)
        })/*
        sensor_type.getSensorsType().then(s=>{
          console.log('succes',s);
        }).catch(e=>{
          console.error('error',e);
        });*/

        console.log('**************** submit Out sensor-type-form *****************');
      }
    }, beforeMount() {
      if (this.Sensor.name === '' || this.Sensor.name == null) {
        this.name_check = true;
      }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/settings/temporarycomponents/sensorTypeForm.vue